import { FILTERS_LOAD } from "@/store/action-types";
import {FILTERS_ACTIVE_SET, FILTERS_COUNT_EXPECTED_SET} from "@/store/mutation-types";
import ResultAjax from "@/components/results/v2-helpers/ajax";

export default {
    methods: {
        getTranslationIfHasAny({ name, type }) {
            let translationKey = `results.${type}_filter`;

            const shouldChangeClassToGroups =
                this.$root.perm('list.eu_change_name_class_to_groups') && translationKey === 'results.class_filter';
            if (shouldChangeClassToGroups) {
                translationKey = 'side_menu.groups'
            }

            const translated = this.$options.filters.lang(translationKey);
            return translated === translationKey ?
                name : translated
        },

        setClearedActiveFilters() {
            let filters = {};
            this.$store.state.filters.list.forEach(f => filters[f.name] = [])
            this.$store.commit(FILTERS_ACTIVE_SET, filters)
        },

        setupReloadFiltersWatcher(isEdit = false, value) {
            if (!isEdit) this.$store.commit(FILTERS_COUNT_EXPECTED_SET, value)

            const recheckEveryNMs = 2000;
            const recheckInterval = setInterval(() => this.recheck(isEdit, value, recheckInterval), recheckEveryNMs)
        },

        async recheck(isEdit, value, recheckInterval) {
            if (this.isRecheckingFilters) return

            this.isRecheckingFilters = true;
            await this.reloadFilters()
            if (this.checkIfExpectedChangeHappened(isEdit, value)) {
                console.log("Expected filter count/change reached, stopping interval")
                clearInterval(recheckInterval)
                this.addNewFiltersToActive(isEdit)
                addEdNotification(
                    this.$options.filters.lang(`filters-from-q.notification-${ isEdit ? 'updated' : 'created' }`),
                    "success"
                );
                this.isRecheckingFilters = false;
                return;
            }

            console.log("Not matched yet, continuing reloading filters")
            this.isRecheckingFilters = false;
        },

        checkIfExpectedChangeHappened(isEdit, value) {
            if (!isEdit) return this.$store.state.filters.count.legacy === value

            const { expectedName, filterId } = value
            return !!this.$store.state.filters.list.filter(f => f.name === expectedName && f.id === filterId).length
        },

        addNewFiltersToActive(isEdit) {
            if (isEdit) {
                this.setClearedActiveFilters();
                return;
            }

            const active = JSON.parse(JSON.stringify(this.$store.state.filters.active))
            this.$store.state.filters.list
                .map(f => f.name)
                .filter(name => !Object.keys(active).includes(name))
                .forEach(name => active[name] = [])
            this.$store.commit(FILTERS_ACTIVE_SET, active)
        },

        async reloadFilters($http = this.$http, surveyPeriodId = this.surveyPeriodId) {
            return this.$store.dispatch(FILTERS_LOAD, { $http, surveyPeriodId })
        },

        getFilters($http = this.$http) {
            return new Promise((resolve, reject) => {
                $http.post(ResultAjax.getEndpoint("filters"), ResultAjax.getPostData(0))
                    .then(response => {
                        resolve(response.body);
                    }).catch(error => {
                    reject(error);
                });
            })
        },

        getVisibility($http = this.$http, surveyPeriodId) {
            return new Promise((resolve, reject) => {
                $http.get(`${window.api_endpoint}/results/${surveyPeriodId}/filters/visibility`)
                    .then(response => {
                        resolve(response.body);
                    }).catch(error => {
                    reject(error);
                });
            })
        },

        getFilter($http = this.$http, surveyPeriodId, filterId) {
            return new Promise((resolve, reject) => {
                $http.get(`${window.api_endpoint}/results/${surveyPeriodId}/filters/${filterId}`)
                    .then(response => {
                        resolve(response.body);
                    }).catch(error => {
                    reject(error);
                });
            })
        },

        createFilterFromQuestion(surveyPeriodId, body) {
            return new Promise((resolve, reject) => {
                this.$http.post(`${window.api_endpoint}/results/${surveyPeriodId}/filters`, body)
                .then(response => {
                    resolve(response.body);
                }).catch(error => {
                    reject(error);
                });
            })
        },

        updateFilterFromQuestion(surveyPeriodId, filterId, body) {
            return new Promise((resolve, reject) => {
                this.$http.put(`${window.api_endpoint}/results/${surveyPeriodId}/filters/${filterId}`, body)
                    .then(response => {
                        resolve(response.body);
                    }).catch(error => {
                    reject(error);
                });
            })
        },

        updateVisibility(surveyPeriodId, body) {
            return new Promise((resolve, reject) => {
                this.$http.put(`${window.api_endpoint}/results/${surveyPeriodId}/filters/visibility`, body)
                    .then(response => {
                        resolve(response.body);
                    }).catch(error => {
                    reject(error);
                });
            })
        },

        deleteFilter(surveyPeriodId, filterId) {
            return new Promise((resolve, reject) => {
                this.$http.delete(`${window.api_endpoint}/results/${surveyPeriodId}/filters/${filterId}`)
                    .then(response => {
                        resolve(response.body);
                    }).catch(error => {
                    reject(error);
                });
            })
        },
    }
}